import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { lossy as _lossy, preserveTransparency as _preserveTransparency, progressive as _progressive } from "../../qualifiers/flag.js";
import { DeliveryAction } from "./DeliveryAction.js";
import { ProgressiveQualifier } from "../../qualifiers/progressive.js";
/**
 * @memberOf Actions.Delivery
 * @extends {Actions.Delivery.DeliveryAction}
 * @see Visit {@link Actions.Delivery|Delivery} for an example
 */
var DeliveryFormatAction = /*#__PURE__*/function (_DeliveryAction) {
  function DeliveryFormatAction(deliveryKey, deliveryType) {
    _classCallCheck(this, DeliveryFormatAction);
    return _callSuper(this, DeliveryFormatAction, [deliveryKey, deliveryType, 'formatType']);
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  _inherits(DeliveryFormatAction, _DeliveryAction);
  return _createClass(DeliveryFormatAction, [{
    key: "lossy",
    value: function lossy() {
      this._actionModel.lossy = true;
      this.addFlag(_lossy());
      return this;
    }
    /**
     * @description Uses progressive compression when delivering JPG file format.
     * @return {this}
     */
  }, {
    key: "progressive",
    value: function progressive(mode) {
      if (mode instanceof ProgressiveQualifier) {
        this._actionModel.progressive = {
          mode: mode.getFlagValue()
        };
        this.addFlag(mode);
      } else {
        this._actionModel.progressive = {
          mode: mode
        };
        this.addFlag(_progressive(mode));
      }
      return this;
    }
    /**
     * @description Ensures that images with a transparency channel are delivered in PNG format.
     */
  }, {
    key: "preserveTransparency",
    value: function preserveTransparency() {
      this._actionModel.preserveTransparency = true;
      this.addFlag(_preserveTransparency());
      return this;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var formatType = actionModel.formatType,
        lossy = actionModel.lossy,
        progressive = actionModel.progressive,
        preserveTransparency = actionModel.preserveTransparency;
      var result;
      if (formatType) {
        result = new this('f', formatType);
      } else {
        result = new this('f');
      }
      if (progressive) {
        if (progressive.mode) {
          result.progressive(progressive.mode);
        } else {
          result.progressive();
        }
      }
      lossy && result.lossy();
      preserveTransparency && result.preserveTransparency();
      return result;
    }
  }]);
}(DeliveryAction);
export { DeliveryFormatAction };